import React from 'react'

function Header() {
    return (
        <div className="header">
    <h1 className="headingTitleh1">Hedlund | Benjamin</h1>
    <h3 className="headingTitleh3">Wedding</h3>
    </div>
    )
}

export default Header
